import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  FaCheckCircle,
  FaEye,
  FaFileAlt,
  FaGavel,
  FaGlobe,
  FaVoteYea
} from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CookieBanner from "../../components/cookies/CookieBanner.tsx";
import Petition from "../../components/petitions/Petition/Petition";
import PetitionsFilter from "../../components/petitions/PetitionsFilter.jsx/PetitionsFilter";
import ArrowRight from "../../components/ui/images/arrow-right.svg";
import CloseModal from "../../components/ui/images/close-modal.svg";
import { checkUserLogin, isUserVerified } from "../../helpers/functions";
import { getPetitions } from "../../store/petition/petitionActions";
import "./Home.scss";

const Home = () => {
  const { petitions, loading } = useSelector((state) => state.petitions);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [isVerifyAccount, setisVerifyAccount] = useState(false);
  const [isShowModal, setIsShowModal] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const firstTenPetitions = petitions?.slice(0, 10);

  useEffect(() => {
    let isLogged = checkUserLogin();
    setIsLoggedIn(isLogged);
  }, [isLoggedIn]);

  useEffect(() => {
    if (isUserVerified()) {
      setIsVerified(true);
    } else {
      setIsVerified(false);
    }
  }, []);

  useEffect(() => {
    dispatch(getPetitions());
  }, []);

  const [t] = useTranslation("global");
  const createMarkup = (text) => {
    return { __html: text.replace(/\n/g, '<br />') };
  };
  return (
    <div className="home">
      <div className="home__content container">
        <main>
          <div className="home__hero">
            <div className="home__hero-content">
              <div className="home__hero-left">
                <div className="home__brand">
                  <p className="home__brand-text">Transparency International</p>
                </div>
                <h1 className="home__hero-title">{t("home_block.name")}</h1>
                <p className="home__hero-description">{t("home_block.davis")}</p>
              </div>
              <div className="home__hero-buttons">
                <button
                  onClick={() => {
                    if (isLoggedIn && isVerified) {
                      navigate("/create-petition");
                    } else if (isLoggedIn && !isVerified) {
                      setisVerifyAccount(true);
                    } else {
                      setIsShowModal(true);
                    }
                  }}
                  className="home__hero-button home__hero-button--primary"
                >
                  <span className="home__hero-button-text">{t("home_block.p1")}</span>
                  <div className="home__hero-button-arrow">↗</div>
                </button>
                <button
                  onClick={() => navigate("/petitions")}
                  className="home__hero-button home__hero-button--secondary"
                >
                  <span className="home__hero-button-text">{t("home_block.p2")}</span>
                  <div className="home__hero-button-arrow">↗</div>
                </button>
              </div>
            </div>
            <div className="home__hero-patterns">
              <div className="home__pattern home__pattern--1"></div>
              <div className="home__pattern home__pattern--2"></div>
              <div className="home__pattern home__pattern--3"></div>
              <div className="home__pattern home__pattern--4"></div>
            </div>
          </div>
        </main>
        <div className="petitions container">
          <h3>{t("home.petitions")}</h3>
          <PetitionsFilter />
          {loading ? (
            <div style={{ height: "50vh" }} className="loadingContainer">
              <h3>{t("home.loading")}</h3>
            </div>
          ) : (
            <div className="container">
              {firstTenPetitions?.map((petition) => (
                <Petition key={petition.id} petition={petition} />
              ))}
            </div>
          )}
          <button
            className="petitions__btn"
            onClick={() => navigate("/petitions")}
          >
            {t("home.watchAllPetitions")} <img src={ArrowRight} alt="arrow" />
          </button>
        </div>
        <div className="steps container">
          <h4 className="steps__title">{t("home.howItWorks")}</h4>
          <div className="steps__grid">
            <div className="steps__card">
              <div className="steps__badge">{t('home.step')} 1</div>
              <div className="steps__header">
                <h5 className="steps__card-title">{t("home.submit_sec")}</h5>
                <div className="steps__icon steps__icon--arrow">
                  <FaFileAlt />
                </div>
              </div>
              <p className="steps__description">{t("home.stepOneText")}</p>
            </div>
            
            <div className="steps__card">
              <div className="steps__badge">{t('home.step')} 2</div>
              <div className="steps__header">
                <h5 className="steps__card-title">{t("home.moderation")}</h5>
                <div className="steps__icon steps__icon--arrow">
                  <FaEye />
                </div>
              </div>
              <p className="steps__description">{t("home.stepTwoText")}</p>
            </div>
            
            <div className="steps__card">
              <div className="steps__badge">{t('home.step')} 3</div>
              <div className="steps__header">
                <h5 className="steps__card-title">{t("home.publishment")}</h5>
                <div className="steps__icon steps__icon--arrow">
                  <FaGlobe />
                </div>
              </div>
              <p className="steps__description">{t("home.stepThreeText")}</p>
            </div>
            
            <div className="steps__card">
              <div className="steps__badge">{t('home.step')} 4</div>
              <div className="steps__header">
                <h5 className="steps__card-title">{t("home.collecting")}</h5>
                <div className="steps__icon steps__icon--arrow">
                  <FaVoteYea />
                </div>
              </div>
              <p className="steps__description">{t("home.stepFourText")}</p>
            </div>
            
            <div className="steps__card">
              <div className="steps__badge">{t('home.step')} 5</div>
              <div className="steps__header">
                <h5 className="steps__card-title">{t("home.consideration")}</h5>
                <div className="steps__icon steps__icon--arrow">
                  <FaGavel />
                </div>
              </div>
              <p className="steps__description">{t("home.stepFiveText")}</p>
            </div>
            
            <div className="steps__card">
              <div className="steps__badge">{t('home.step')} 6</div>
              <div className="steps__header">
                <h5 className="steps__card-title">{t("home.decision")}</h5>
                <div className="steps__icon steps__icon--check">
                  <FaCheckCircle />
                </div>
              </div>
              <p className="steps__description">{t("home.stepSixText")}</p>
            </div>
          </div>
          {isShowModal && (
            <div className="petition-modal">
              <div className="petition-modal__content">
                <div className="petition-modal-top">
                  <p>{t("home.login")}</p>
                  <img
                    src={CloseModal}
                    alt="close"
                    onClick={() => setIsShowModal(false)}
                  />
                </div>
                <div className="petition-modal__middle">
                  {t("home.loginInstruction")}
                </div>
                <hr></hr>
                <div className="petition-modal__bottom">
                  <button
                    className="petition-modal__cancel"
                    onClick={() => setIsShowModal(false)}
                  >
                    {t("home.cancelBtn")}
                  </button>
                  <button
                    className="petition-modal__sign-in"
                    onClick={() => {
                      navigate("/login");
                      setIsShowModal(false);
                    }}
                  >
                    {t("home.loginBtn")}
                  </button>
                </div>
              </div>
            </div>
          )}
          <div className="steps__btn container">
            <button
              onClick={() => {
                if (isLoggedIn && isVerified) {
                  navigate("/create-petition");
                } else if (isLoggedIn && !isVerified) {
                  setisVerifyAccount(true);
                } else {
                  setIsShowModal(true);
                }
              }}
            >
              {t("home.submit")}
            </button>
          </div>
          {isVerifyAccount && (
            <div className="petition-modal">
              <div className="petition-modal__content">
                <div className="petition-modal-top">
                  <p>{t('navbar.verifyAccount')}</p>
                  <img
                    src={CloseModal}
                    alt="close"
                    onClick={() => setisVerifyAccount(false)}
                  />
                </div>
                <div className="petition-modal__middle">
                  {t('navbar.verifyRules')}
                </div>
                <hr></hr>
                <div className="petition-modal__bottom">
                  <button
                    className="petition-modal__cancel"
                    onClick={() => setisVerifyAccount(false)}
                  >
                    {t('home.cancelBtn')}
                  </button>
                  <button
                    className="petition-modal__sign-in"
                    onClick={() => {
                      navigate("/profile");
                      setisVerifyAccount(false);
                    }}
                  >
                    {t('navbar.goVerify')}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <CookieBanner />
    </div>
  );
};

export default Home;
